(function (process){
var isDev;

isDev = false;

if (process.env.NODE_ENV !== 'production') {
  isDev = true;
}

module.exports = isDev;


}).call(this,require('_process'))
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL2hlbHBlcnMvaXMtZGV2LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsidmFyIGlzRGV2O1xuXG5pc0RldiA9IGZhbHNlO1xuXG5pZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgIT09ICdwcm9kdWN0aW9uJykge1xuICBpc0RldiA9IHRydWU7XG59XG5cbm1vZHVsZS5leHBvcnRzID0gaXNEZXY7XG5cbiJdfQ==